export default {
  data() {
    return {
      headerSettings: {
        logoLink: this.$i18n.locale === 'cs' ? import.meta.env.VITE_OLD_WEB_URL : 'index',
        isLogoExternal: this.$i18n.locale === 'cs',
        externalLogoTarget: '_self'
      },
      languageSwitcherOverridePaths: ['index']
    };
  }
};
